import { render, staticRenderFns } from "./CommunicationLogs.vue?vue&type=template&id=4f30fc0c&scoped=true"
import script from "./CommunicationLogs.vue?vue&type=script&lang=js"
export * from "./CommunicationLogs.vue?vue&type=script&lang=js"
import style0 from "./CommunicationLogs.vue?vue&type=style&index=0&id=4f30fc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30fc0c",
  null
  
)

export default component.exports